// removed by extract-text-webpack-plugin
module.exports = {"Btn":"zNnK6dZD_vjMHAdSfSUMM"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/ProjectAdd/styles.module.css
// module id = 545
// module chunks = 0